import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  product: {},

  page: 1,
  totalPage: 2,
  pageInfo: {},
  products: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
